import React from 'react';

import { Box, Icon } from '@rbilabs/universal-components';

import { DELIVERY_PROGRESS_COLOR } from './constants';

// This adds a backfill for the icon viewbox
const backfillMargin = '3px';
const Backfill = Box.withConfig({
  position: 'absolute',
  background: {
    base: Styles.color.white,
    md: 'none',
  },
  borderRadius: 'full',
  top: backfillMargin,
  left: backfillMargin,
  right: backfillMargin,
  bottom: backfillMargin,
});

interface ProgressCheckpointProps {
  isActive: boolean;
}

const ProgressCheckpoint: React.VFC<ProgressCheckpointProps> = ({ isActive }) => {
  return (
    <Box>
      <Backfill />
      <Icon
        variant="checkFill"
        color={isActive ? DELIVERY_PROGRESS_COLOR : Styles.color.grey.four}
      />
    </Box>
  );
};

export default ProgressCheckpoint;
